var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.image,
          expression: "image"
        }
      ],
      staticClass: "advert-wrap"
    },
    [
      _c("a", { attrs: { href: _vm.link }, on: { click: _vm.processClick } }, [
        _c("img", { attrs: { src: _vm.image } })
      ]),
      _vm._v(" "),
      _c("p", [
        _c(
          "a",
          {
            staticClass: "click",
            attrs: { href: _vm.link },
            on: { click: _vm.processClick }
          },
          [_vm._v(_vm._s(_vm.linktext))]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }